<!--suppress ALL -->
<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'gestion-gastos' }">{{
                $t("gastos")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ verificado === 1 ? $t("visualizar") : action }} {{ $t("gasto") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h2 class="tituloNumier" style="display:flex; justify-content:space-between; align-items: center">
                <div><i class="fa fa-building"></i> {{ nombreNegocio }}</div>
                <div v-if="identificadorContable">
                  <bold>
                    {{ $t("identificador") }} : {{ identificador }}
                  </bold>
                </div>
              </h2>
              <hr />

            </div>

            <div class="col-md-4">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <label><strong>{{ $t("proveedores") }}</strong>
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-6 text-right" v-if="verificado !== 1">
                    <span @click="openModalnuevoProveedores()">
                      <span class="small text-primary" style="cursor: pointer">{{ $t("nuevoProveedor") }}</span>
                      <i v-tooltip.top-center="$t('crearNuevoProveedor')" class="fas fa-plus-circle"
                        style="color: #1E22AA; cursor: pointer"></i>
                    </span>
                  </div>
                </div>
                <el-select class="select-default" size="large" :disabled="vista === 1 || verificado === 1"
                  v-model="idSupplier" filterable :placeholder="$t('seleccionaNegocio')">
                  <el-option v-for="su in listProveedores" class="select-primary" :value="su.id" :label="su.name"
                    :key="su.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="referencia-gasto"><strong>{{ $t("referencia") }}</strong>
                  <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="ref" :disabled="vista === 1 || verificado === 1"
                  id="referencia-gasto" />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label for="importe-gasto"><strong>{{ $t("importe") }}</strong>
                  <span class="text-danger">*</span></label>
                <vue-numeric currency="€" id="importe-gasto" inputmode="decimal" type="text"
                  :disabled="vista === 1 || (verificado === 1 && vista !== 2)" v-bind:minus="true" class="form-control"
                  currency-symbol-position="suffix" :precision="2" v-model="importe"
                  @keydown="$methods.evitarComasDecimales">
                </vue-numeric>
              </div>
            </div>

            <div class="col-md-4">
              <label><strong>{{ $t("tipoDeDocumento") }}</strong></label>
              <div class="form-group" id="layoutTipoDocumento">
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="tipo" label="F">{{
                  $t("factura")
                }}</el-radio>
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="tipo" label="A">{{
                  $t("albaran")
                }}</el-radio>
              </div>
            </div>

            <div class="col-md-4">
              <label><strong>{{ $t("formaDePago") }}</strong></label>
              <div class="form-group" id="layoutTipoDocumento">
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="formaPago" :label="0">{{
                  $t("transferencia")
                }}
                </el-radio>
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="formaPago" :label="1">{{
                  $t("domiciliacion")
                }}
                </el-radio>
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="formaPago" :label="2">{{ $t("efectivo")
                  }}
                </el-radio>
                <el-radio :disabled="vista === 1 || verificado === 1" v-model="formaPago" :label="3">{{ $t("tarjeta")
                  }}
                </el-radio>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>{{ $t("fechaGasto") }}</label>
                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                  :title="$t('fechaInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control" v-model="fecha"></datetime>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label for="observaciones-gasto"><strong>{{ $t("observaciones") }} </strong></label>
                <input type="text" class="form-control" v-model="observaciones"
                  :disabled="vista === 1 || verificado === 1" id="observaciones-gasto" />
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label> </label>
                <el-checkbox :disabled="vista === 1 || verificado === 1" v-model="entradaAlmacen">
                  {{ $t("generarEntradaDeAlmacenAlVerificar") }}
                </el-checkbox>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12">
              <h5>
                {{ $t("listaDeMateriaPrima") }}
                <i @click="openModalnuevoSubproducto()" v-tooltip.top-center="$t('crearMateriaPrima')"
                  v-if="verificado !== 1" class="fas fa-plus-circle" style="color: #1E22AA; cursor: pointer"></i>
              </h5>
            </div>

            <div class="col-md-12" style="margin-bottom: 10px">
              <div class="checkbox">
                <el-checkbox :disabled="vista === 1 || (verificado === 1 && vista !== 2)" v-model="incluirIVA">{{
                  $t("preciosIVAIncluido")
                }}
                </el-checkbox>
              </div>
            </div>

            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th width="20%">{{ $t("nombre") }}</th>
                      <th width="10%">{{ $t("uds") }}.</th>
                      <th width="10%">{{ $t("partes") }}</th>
                      <th width="10%">{{ $t("precioSinIVA") }}</th>
                      <th width="10%">{{ $t("precioIVAInc") }}.</th>
                      <th width="10%">{{ $t("porcentajeDto") }}.</th>
                      <th width="10%">{{ $t("base") }}</th>
                      <th width="10%">{{ $t("IVA") }}</th>
                      <th width="15%">{{ $t("total") }}</th>
                      <th v-if="vista !== 1 && vista !== 2" width="5%">{{ $t("casa") }}</th>
                      <th v-if="vista !== 1 && vista !== 2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, index) in listSubproductSelect">
                      <td>
                        {{ p.name }}<br />
                        <span style="font-size:0.9em; color: #757272">({{ p.type }} - {{ $t("escandallo") }}:
                          {{ p.escandallo }})</span>
                      </td>
                      <td>
                        <input class="form-control" type="number"
                          onkeydown="if(event.key==='.'){event.preventDefault();}" placeholder="0"
                          :disabled="vista === 1 || verificado === 1" @blur="changeProduct(p)" @keyup="changeProduct(p)"
                           @keydown="$methods.evitarComasDecimales" v-model="p.und" />

                      </td>

                      <td>
                        <input class="form-control" type="number"
                          onkeydown="if(event.key==='.'){event.preventDefault();}" placeholder="0" :disabled="
                            vista === 1 || verificado === 1 ||
                            p.escandallo === 1 ||
                            p.escandallo === 0
                          " @blur="changeProduct(p)" @keyup="changeProduct(p)" @keydown="$methods.evitarComasDecimales"
                          v-model="p.partes" />
                      </td>
                      <td>
                        <div class="d-inline-flex align-items-center">
                          <vue-numeric currency="€" class="form-control" inputmode="decimal" type="text"
                            currency-symbol-position="suffix"
                            :disabled="vista === 1 || (verificado === 1 && vista !== 2)" :precision="4"
                            @blur="changeProduct(p)" @keyup="changeProduct(p)"
                            @change="checkAndShowAlert(p.precioCompraSinIva, p.precioCompraSinIvaInicial, p.name)"
                            @keydown="$methods.evitarComasDecimales" v-model="p.precioCompraSinIva">
                          </vue-numeric>

                          <i v-if="idBusiness == 5831 && (p.precioCompraSinIva !== p.precioCompraSinIvaInicial) && p.precioHaCambiado" 
                            v-tooltip.top-center="getPrecioFijadoTooltip(p.precioCompraSinIva, p.precioCompraSinIvaInicial)"
                            class="fas fa-triangle-exclamation ml-2" style="color: #ff8800; cursor: pointer">
                            

                          </i>
                          <i v-if="p.porcentajeCompra != 0 && (p.precioCompraSinIva >= p.precioCompraSinIvaInicial + (p.precioCompraSinIvaInicial * p.porcentajeCompra / 100) || p.precioCompra <= p.precioCompraInicial - (p.precioCompraInicial * p.porcentajeCompra / 100))"
                            v-tooltip.top-center="p.precioCompra >= p.precioCompraInicial + (p.precioCompraInicial * p.porcentajeCompra / 100) ? $t('mensajePorcentajeCompraAumento') + ' (' + p.porcentajeCompra + '%)' : $t('mensajePorcentajeCompraDisminuido') + ' (' + p.porcentajeCompra + '%)'"
                            class="fas fa-triangle-exclamation ml-2" style="color: #ff8800; cursor: pointer"></i>

                        </div>
                      </td>
                      <td>
                        <div class="d-inline-flex align-items-center">
                          <vue-numeric currency="€" class="form-control" inputmode="decimal" type="text"
                            currency-symbol-position="suffix" :disabled="!incluirIVA || vista === 1 || (verificado === 1 && vista !== 2)"
                            :precision="4" @blur="changeProduct(p)" @keyup.native="changeProduct(p)"
                            @keydown.native="$methods.evitarComasDecimales" v-model="p.precioCompra">
                          </vue-numeric>
                          <i  v-if="p.porcentajeCompra != 0 && (p.precioCompra >= p.precioCompraInicial + (p.precioCompraInicial * p.porcentajeCompra / 100) || p.precioCompra <= p.precioCompraInicial - (p.precioCompraInicial * p.porcentajeCompra / 100)) " v-tooltip.top-center="p.precioCompra >= p.precioCompraInicial + (p.precioCompraInicial * p.porcentajeCompra / 100) ? $t('mensajePorcentajeCompraAumento') + ' (' + p.porcentajeCompra + '%)' : $t('mensajePorcentajeCompraDisminuido') + ' (' + p.porcentajeCompra + '%)'" class="fas fa-triangle-exclamation ml-2"
                          style="color: #ff8800; cursor: pointer"></i>
                        </div>
                      </td>

                      <td>
                        <input class="form-control" type="number" :disabled="vista === 1 || (verificado === 1 && vista !== 2)"
                          @blur="changeProduct(p)" @keyup="changeProduct(p)" @keydown="$methods.evitarComasDecimales"
                          v-model="p.dtoCompra" />
                      </td>

                      <td align="center">
                        <!-- <div>{{ p.base | currencyGastos }}</div> -->
                        <div>{{ p.base.toFixed(4) }} €</div>
                      </td>
                      <td>
                        <el-select v-model="p.iva" @change="changeProduct(p)" @keyup="changeProduct(p)"
                          :disabled="vista === 1 || (verificado === 1 && vista !== 2)" class="select-default">
                          <el-option v-for="iva in listIva" :key="iva" :label="iva" :value="iva">
                          </el-option>
                        </el-select>
                      </td>
                      <td align="center">
                        <!-- <div>{{ p.total | currencyGastos }}</div> -->
                        <div>{{ p.total.toFixed(4) }} €</div>
                      </td>
                      <td align="center" v-if="vista !== 1 && vista !== 2">
                        <i v-if="(p.idCasa === '0') | (p.idCasa === 0)" v-tooltip.top-center="$t('sinCasaAsignada')"
                          @click="openModal(p, index)" class="fas fa-home" style="cursor: pointer"></i>
                        <i v-else v-tooltip.top-center="p.nameCasa" @click="openModal(p, index)"
                          class="fas fa-home text-primary" style="cursor: pointer"></i>
                      </td>
                      <td align="center" v-if="vista !== 1 && vista !== 2">
                        <i @click="removeSubproduct(index)" v-tooltip.top-center="$t('eliminarMateriaPrima')"
                          class="fas fa-minus-circle text-danger" style="cursor: pointer"></i>
                      </td>
                    </tr>
                    <tr class="bg-add-subproduct">
                      <td colspan="11">
                        <el-autocomplete v-model="idProducto" style="width: 50%" :fetch-suggestions="searchSubproductos"
                          :placeholder="$t('buscarPorRefONombreDeLaMateriaPrima')
                            " :trigger-on-focus="false" :disabled="vista === 1 || verificado === 1"
                          @select="selectSubproduct">
                          <template slot-scope="{ item }">
                            <div class="value">{{ item.name }}</div>
                          </template>
                        </el-autocomplete>

                        <!--<el-select-->
                        <!--class="select-default"-->
                        <!--v-model="idProducto"-->
                        <!--:aria-readonly="false"-->
                        <!--filterable-->
                        <!--style="width: 100%"-->
                        <!--remote-->
                        <!--:disabled="vista===1"-->
                        <!--reserve-keyword-->
                        <!--placeholder="Buscar por Ref. o Nombre de la materia prima"-->
                        <!--@change="selectSubproduct()"-->
                        <!--:remote-method="searchSubproductos">-->
                        <!--<el-option-->
                        <!--v-for="p in listProductos"-->
                        <!--:key="p.id"-->
                        <!--:label="p.name"-->
                        <!--:value="p.id">-->
                        <!--</el-option>-->
                        <!--</el-select>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-6 text-left">
              <div v-if="listImportesIva.length > 0" class="table-responsive">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("baseImponible") }}</th>
                      <th>{{ $t("iva") }}</th>
                      <th>{{ $t("cuotaIVA") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(iva, index) in listImportesIva">
                      <!-- <td >{{ iva.baseImponible | currencyGastos }}</td> -->
                      <td>{{ (iva.baseImponible).toFixed(2) }} €</td>
                      <td>{{ iva.IVA }}</td>
                      <!-- <td >{{ iva.importe | currencyGastos }}</td> -->
                      <td>{{ (iva.importe).toFixed(2) }} €</td>
                    </tr>
                  </tbody>
                </table>

              </div>

            </div>
            <div class="col-md-6 text-right">
              <p>
                <!-- <strong><big>{{ $t("totalBase") }}: {{ base | currencyGastos }}</big></strong> -->
                <strong><big>{{ $t("totalBase") }}: {{ base.toFixed(2) }} €</big></strong>
              </p>
              <p>
                <strong><big>{{ $t("totalImpuestoIva") }}: {{ getTotalImpuesto | currencyGastos }}</big></strong>
              </p>
              <p>
                <!-- <strong><big>{{ $t("totalDocumento") }}: {{ importe | currencyGastos }}</big></strong> -->
                <strong><big>{{ $t("totalDocumento") }}: {{ importe.toFixed(2) }} €</big></strong>
              </p>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <button v-if="vista == 1 || this.verificado != 1 || vista == 2 || vista == 0" @click="checkReference()"
                  class="btn btn-primary">
                  <!--@click="saveGasto()"-->
                  <i class="fa fa-check-square"></i>
                  {{ $t("guardar") }}
                </button>

                <router-link :to="{ name: 'gestion-gastos' }">
                  <button class="btn btn-danger">
                    <i class="fa fa-window-close"></i>
                    {{ $t("cancelar") }}
                  </button>
                </router-link>
              </div>
            </div>

            <modal name="agregar-casa" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
              <div>
                <div class="modal-header"></div>
                <div class="modal-body">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label><strong>{{ $t("seleccioneUnaCasa") }}:</strong></label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-default" @click="cerrarModal()">
                    <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                  </button>
                  <button @click="accionarModal()" class="btn btn-primary">
                    <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
                  </button>
                </div>
              </div>
            </modal>

            <modal name="modal-crear-subproductos" :adaptive="true" :scrollable="true" height="auto"
              :clickToClose="true">
              <div>
                <div class="modal-header">
                  <h5>{{ $t("anyadirNuevoSubproducto") }}</h5>
                </div>
                <div class="modal-body">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label><strong>{{ $t("etiqueta") }}</strong></label>

                          <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                            :placeholder="$t('seleccioneEtiqueta')">
                            <el-option v-for="category in listCategorySub" class="select-primary" :value="category.id"
                              :label="category.name" :key="category.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label><strong>{{ $t("proveedor") }}</strong></label>
                          <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                            :placeholder="$t('seleccionaNegocio')">
                            <el-option v-for="proveedor in listProveedoresSub" class="select-primary"
                              :value="proveedor.id" :label="proveedor.name" :key="proveedor.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameCasa"><strong>{{ $t("nombreSubproducto") }}
                              <span>*</span></strong></label>
                          <input type="text" class="form-control" :class="{
                            'is-valid':
                              subproducto.name.length > 0 &&
                              subproducto.name.length <= 50,
                            'is-invalid': subproducto.name.length > 50,
                          }" id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name"
                            ref="name" />
                          <input type="hidden" v-model="subproducto.xname" />
                          <small class="form-text text-muted">{{ subproducto.name.length }}/50
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="codigodebarrasubproducto">
                            <strong>{{ $t("codigoBarra") }}</strong>
                          </label>
                          <input type="text" class="form-control" id="codigodebarrasubproducto"
                            v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="direccionsubproducto"><strong>{{ $t("descripcion") }}</strong></label>
                          <input type="text" class="form-control" id="direccionsubproducto"
                            v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label><strong>{{ $t("tipo") }}</strong></label>

                          <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                            :placeholder="$t('seleccionaNegocio')">
                            <el-option v-for="tipo in listaTipo" class="select-primary" :value="tipo" :label="tipo"
                              :key="tipo">
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="escandalloSubproducto"><strong>{{ $t("escandallo") }}</strong></label>
                          <!--<input type="number" min="0" class="form-control"
                                                           id="escandalloSubproducto"
                                                           v-bind:placeholder="$t('introduzcaEscandallo')"
                                                           v-model="subproducto.escandallo">-->
                          <el-input-number id="escandalloSubproducto" v-model="subproducto.escandallo" :min="0"
                            :precision="0" :controls="false" :placeholder="$t('introduzcaEscandallo')">
                          </el-input-number>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioCompraSubproductoSinIva"><strong>{{
                            $t("precioCompraSinIva")
                              }}</strong>
                          </label>
                          <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                          <!--type="number"-->
                          <!--id="precioCompraSubproductoSinIva"-->
                          <!--@change="calculatePrice(subproducto,false)"/>-->


                          <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                            currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, false)"
                            @keydown="$methods.evitarComasDecimales" v-model="subproducto.precioCompraSinIva">
                          </vue-numeric>

                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label><strong>{{ $t("tipoIva") }}</strong></label>

                          <el-select class="select-default" size="large" v-model="subproducto.tipoIva" filterable
                            @change="calculatePrice(subproducto, false)" :placeholder="$t('seleccionaNegocio')">
                            <el-option v-for="iva in listIva" class="select-primary" :value="iva" :label="iva"
                              :key="iva">
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cuotaIVA"><strong>{{ $t("cuotaIVA") }}</strong></label>
                          <input class="form-control"
                            :value="cuotaIvaModal(subproducto.precioCompra, subproducto.precioCompraSinIva)"
                            type="number" disabled id="cuotaIVA" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioCompraSubproducto"><strong>{{
                            $t("precioCompraConIva")
                              }}</strong></label>
                          <vue-numeric currency="€" class="form-control" inputmode="decimal" type="text"
                            currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                            @keydown="$methods.evitarComasDecimales" v-model="subproducto.precioCompra">
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="descuentoCompraSubproducto"><strong>{{ $t("descuentoCompra")
                              }}</strong></label><span style="font-size: x-small">
                            {{ $t("porcentaje") }}</span>
                          <input type="number" min="0" class="form-control" id="descuentoCompraSubproducto"
                            placeholder="0%" v-model="subproducto.descuentoCompra" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <hr />
                      </div>

                      <div class="col-md-6" style="padding-top: 35px">
                        <div class="form-group">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("baja") }}</strong>
                            </label>
                            <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                            </el-switch>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6" style="padding-top: 35px">
                        <div class="form-group">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("guardarEnAlmacen") }}</strong>
                            </label>
                            <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66"
                              inactive-color="#bcbcbc">
                            </el-switch>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="stockMinimoSubproducto"><strong>{{
                            $t("unidadesStockMinimo")
                              }}</strong></label>
                          <input type="number" min="0" class="form-control" id="stockMinimoSubproducto"
                            v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="stockMinimoPartesSubproducto"><strong>{{
                            $t("partesStockMinimo")
                              }}</strong></label>
                          <input type="number" min="0" class="form-control" id="stockMinimoPartesSubproducto"
                            v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimoPartes" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="stockOptimoSubproducto"><strong>{{ $t("stockOptimo") }}</strong></label>
                          <input type="number" min="0" class="form-control" id="stockOptimoSubproducto"
                            v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
                        </div>
                      </div>

                      <div v-if="listCuentasSage.length > 1" class="col-md-6">
                        <div class="form-group">
                          <label for="idCuenta"><strong>{{
                            tieneDimoni ? $t("enlaceContable") : $t("sage200")
                              }}</strong></label>
                          <el-select class="select-default select-account" v-model="subproducto.idCuenta" filterable
                            :placeholder="$t('seleccioneUnaCuenta')">
                            <el-option v-for="cuenta in listCuentasSage" class="select-primary" :value="cuenta.id"
                              :label="cuenta.codigoCuenta +
                                cuenta.codigoSubCuenta +
                                ' - ' +
                                cuenta.nombreCuenta
                                " :key="cuenta.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-default" @click="cerrarModal()">
                    <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                  </button>
                  <button @click="saveSubproducto()" class="btn btn-primary">
                    <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
                  </button>
                </div>
              </div>
            </modal>

            <modal name="modal-crear-proveedores" :adaptive="true" :scrollable="true" height="auto"
              :clickToClose="true">
              <div>
                <div class="modal-header">
                  <h5>{{ $t("anadirProveedor") }}</h5>
                </div>
                <div class="modal-body">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label><strong>{{ $t("category") }}</strong></label>

                          <el-select class="select-default" size="large" v-model="proveedor.idCategory" filterable
                            :placeholder="$t('seleccionaNegocio')">
                            <el-option v-for="category in listCategoryProveedor" class="select-primary"
                              :value="category.id" :label="category.name" :key="category.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameCasa"><strong>{{ $t("nombreProveedor") }}
                              <span style="color: red">*</span></strong></label>
                          <input type="text" class="form-control" :class="{
                            'is-valid':
                              proveedor.name.length > 0 &&
                              proveedor.name.length <= maxNameProveedor,
                            'is-invalid':
                              proveedor.name.length > maxNameProveedor,
                          }" id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="proveedor.name"
                            ref="name" />
                          <small class="form-text text-muted">{{ proveedor.name.length }}/50
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cifnifproveedor"><strong>{{ $t("cifNif") }}</strong></label>
                          <input type="text" class="form-control" id="cifnifproveedor"
                            v-bind:placeholder="$t('introduzcaCifNif')" v-model="proveedor.cifnif" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="addressproveedor"><strong>{{ $t("direccion") }}</strong></label>
                          <input type="text" class="form-control" id="addressproveedor"
                            v-bind:placeholder="$t('introduzcaDireccion')" v-model="proveedor.address" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="provinceCasa"><strong>{{ $t("provincia") }}</strong></label>
                          <input type="text" class="form-control" id="provinceCasa"
                            v-bind:placeholder="$t('introduzcaProvincia')" v-model="proveedor.province" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cityCasa"><strong>{{ $t("ciudad") }}</strong></label>
                          <input type="text" class="form-control" id="cityCasa"
                            v-bind:placeholder="$t('introduzcaCiudad')" v-model="proveedor.city" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cpCasa"><strong>{{ $t("codigoPostal") }}</strong></label>
                          <input type="text" class="form-control" id="cpCasa"
                            v-bind:placeholder="$t('introduzcaCodigoPostal')" v-model="proveedor.cp" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="phoneCasa"><strong>{{ $t("telefono") }}</strong></label>
                          <input type="text" class="form-control" id="phoneCasa"
                            v-bind:placeholder="$t('introduzcaTelefono')" v-model="proveedor.phone" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="emailCasa"><strong>{{
                            $t("correoElectronico")
                              }}</strong></label>
                          <input type="text" class="form-control" id="emailCasa"
                            v-bind:placeholder="$t('introduzcaCorreo')" v-model="proveedor.email" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="emailCasa"><strong>{{
                            'IBAN'
                              }}</strong></label>
                          <input type="text" class="form-control" id="ibanProveedor"
                            v-bind:placeholder="'Introduzca IBAN'" v-model="proveedor.iban" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="emailCasa"><strong>{{
                            'Número registro sanitario'
                              }}</strong></label>
                          <input type="text" class="form-control" id="ibanProveedor"
                            v-bind:placeholder="'Introduzca número registro sanitario'"
                            v-model="proveedor.numeroRegistroSanitario" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("acreedor") }}</strong>
                            </label>
                            <el-switch v-model="proveedor.acreedor" active-color="#13ce66" inactive-color="#bcbcbc">
                            </el-switch>

                            <span style="font-size: small">{{
                              $t("infoAcreedor")
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="form-group">
                            <label>
                              <strong>{{ $t("baja") }}</strong>
                            </label>
                            <el-switch v-model="proveedor.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-default" @click="cerrarModal()">
                    <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                  </button>
                  <button @click="saveProveedor()" class="btn btn-primary">
                    <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
                  </button>
                </div>
              </div>
            </modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import moment from "moment";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Autocomplete,
  Switch,
  Radio,
} from "element-ui";
import { Loading } from "element-ui";
import {
  atan2, chain, derivative, e, evaluate, log, pi, pow, round, sqrt
} from 'mathjs'

export default {
  name: "GestionGastoForm",
  props: ["idBusiness", "idGasto", "vista"],
  data() {
    return {
      action: "Nuevo",
      tipo: "F",
      nombreNegocio: "",
      ref: "",
      nameCasa: "",
      observaciones: "",
      listProductos: [],
      listCasas: [],
      listProveedores: [],
      listSubproductSelect: [],
      listSuppliers: [],
      listImportesIva: [],
      listIva: [0, 4, 10, 21],
      porcentajeAcordado: "0", 
      idProducto: "",
      idSupplier: 0,
      idCasa: 0,
      importe: 0,
      fecha: new Date().toISOString(),
      entradaAlmacen: true,
      incluirIVA: false,
      indice: 0,
      loading: null,
      base: 0,
      //importeBase: 0,
      formaPago: 0,
      verificado: 0,
      // MODAL SUBPRODUCTOS
      subproducto: {
        idTag: 0,
        idSupplier: 0,
        idCasa: 0,
        orden: 999,
        name: "",
        xname: "",
        descripcion: "",
        codigoBarras: "",
        tipo: "Uds.",
        tipoIva: 10,
        descuentoCompra: 0,
        precioCompra: 0,
        precioCompraSinIva: 0,
        escandallo: 1,
        stockMinimo: 0.0,
        stockMinimoPartes: 0.0,
        stockOptimo: 0.0,
        color: "amarillo",
        guardarAlmacen: true,
        baja: false,
        idCuenta: "0",
        noMostrarInformeSectores: 0,
        fixed_price_state: true,
      },
      identificadorContable: false,
      idTpv: "",
      listCategorySub: [],
      listCasasSub: [],
      listProveedoresSub: [],
      listIva: [0, 4, 10, 21],
      listaTipo: [
        "Uds.",
        this.$t("cajas"),
        this.$t("botellas"),
        this.$t("barriles"),
        this.$t("palets"),
        this.$t("bolsas"),
        "Kgs",
        this.$t("litros"),
        this.$t("rollos"),
      ],
      listCuentasSage: [],
      porcentajeAcordado: 0,
      //MODAL PROVEEDOR
      proveedor: {
        name: "",
        xname: "",
        cifnif: "",
        address: "",
        province: "",
        city: "",
        cp: "",
        phone: "",
        email: "",
        acreedor: false,
        idCategory: 0,
        baja: false,
        idCuenta: "0",
        idCuentaApunte: "0",
        iban: "",
        numeroRegistroSanitario: "",
        porcentajeAcordado: 0
      },
      listCategoryProveedor: [],
      maxNameProveedor: 50,

      tieneDimoni: false,
    };
    
  },
  computed: {
    getTotalBase() {

      let baseTotal = 0;

      this.listImportesIva.forEach(function (d) {

        //baseTotal += Math.round(d.baseImponible * 100) / 100;
        baseTotal = round((baseTotal + d.baseImponible), 3);
      });


      return baseTotal;

    },

    getTotalImpuesto() {
      let impuesto = 0;

      this.listImportesIva.forEach(function (d) {

        //impuesto += Math.round(d.importe * 100) / 100;
        impuesto = round((impuesto + d.importe), 2);

      });

      return impuesto;
    },

    getTotalTotal() {

      let total = 0;
      let impuesto = 0;
      let base = 0;

      this.listImportesIva.forEach(function (d) {


        base = round((base + d.baseImponible), 3);

        impuesto = round((impuesto + d.importe), 3);


      });

      let result = base + impuesto;

      return round(result, 3);
    },

    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [Autocomplete.name]: Autocomplete,
  },

  created() {
    this.identificacionNegocio();
    this.getIdTpvByBusiness();
    this.getProveedores();
    this.getCasas();
    this.getTaxes();
    this.getConfigDimoni();

    if (this.idGasto) {
      this.getConfigIdentificador();
      this.getGasto();
    } else {
      this.action = $t("nuevo");
    }

  },
  methods: {

    getConfigDimoni() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "clients/tieneDimoni", config)
        .then(function (response) {
          if (response.data.result) {
            vm.tieneDimoni = true;
          } else {
            vm.tieneDimoni = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getConfigIdentificador() {
      let vm = this;

      let configIdentificador = '100';

      var config = {
        params: {

          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
        .then(function (response) {

          if (response.data.response) {

            vm.identificadorContable = response.data.result;

          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getIdTpvByBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
        .then(function (response) {

          vm.idTpv = response.data;

          vm.cargarCuentasPorIdTpv();

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cargarCuentasPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/getSageBusinessDataByIdTpv",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCuentasSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });

            response.data.result.forEach((cuenta) => {
              if (cuenta.tipo == "G") {
                vm.listCuentasSage.push(cuenta);
              }
            });

            vm.respuesta = true;
          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTaxes() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "taxes/getOnlyTaxes", config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.listIva = response.data.result;
              vm.subproducto.tipoIva = response.data.result[0];
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    resetAlertFlag(product) {
      // Si el precio vuelve a ser el precio inicial, reiniciamos la bandera
      if (product.precioCompraSinIva === product.precioCompraSinIvaInicial) {
        this.alertShown = false;
      }
    },
    changeProduct(product, mantener = false) {
      // Cálculo del precio sin IVA o con IVA
      if (this.incluirIVA) {
        product.precioCompraSinIva = mantener
          ? product.precioCompraSinIva
          : round(product.precioCompra / (1 + product.iva / 100), 4);
      } else {
        product.precioCompra = mantener
          ? product.precioCompra
          : round(product.precioCompraSinIva * (1 + product.iva / 100), 4);
      }

      // Calcular la base imponible
      let descuento = (product.dtoCompra * product.precioCompraSinIva) / 100;
      let base = mantener
        ? product.totalBase
        : round((product.precioCompraSinIva - descuento) * product.und, 4);

      // Incluir partes adicionales si las hay
      if (product.partes != 0) {
        base += round((product.partes / product.escandallo) * (product.precioCompraSinIva - descuento), 4);
      }

      // Si no estamos manteniendo el estado, recalcular IVA
      if (!mantener) {
        this.calcularIvaLista();
      }

      // Actualizar importes de IVA en la lista
      this.listImportesIva.forEach((iva) => {
        iva.importe = round(iva.baseImponible * (iva.IVA / 100), 4);
      });

      // Redondear y asignar valores finales
      base = round(base, 4);
      product.base = base;

      let total = round(base * (1 + product.iva / 100), 4);
      product.total = mantener ? product.total : total;

      // Actualizar totales generales
      this.importe = mantener ? this.importe : this.getTotalTotal;
      this.base = this.getTotalBase;

      this.resetAlertFlag(product);
    },
    calcularIvaLista() {
      this.listImportesIva = []

      this.listSubproductSelect.forEach((subpro) => {
        let importeBase = 0;

        if (subpro.dtoCompra != 100) {
          importeBase = (subpro.precioCompraSinIva - (subpro.dtoCompra * subpro.precioCompraSinIva) / 100) * subpro.und;
        } else {

          importeBase = 0;

        }

        if (subpro.partes != 0) {

          importeBase = importeBase + (subpro.partes / subpro.escandallo) * (subpro.precioCompraSinIva - (subpro.dtoCompra * subpro.precioCompraSinIva) / 100);

        }

        importeBase = round(importeBase, 4);


        if (this.listImportesIva.find((e) => e.IVA === subpro.iva.toString())) {

          var index = this.listImportesIva.findIndex((e) => e.IVA === subpro.iva.toString());

          let baseTotal = this.listImportesIva[index].baseImponible;
          baseTotal = round(baseTotal, 4)
          this.listImportesIva[index].baseImponible = baseTotal + importeBase;

        } else {

          this.listImportesIva.push({

            "baseImponible": importeBase,
            "IVA": subpro.iva.toString(),
            "importe": importeBase * (subpro.iva / 100)

          });

        }

        this.listImportesIva.sort((a, b) => a.IVA - b.IVA);

      });

    },

    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getProveedores() {
      const controller = "getSuppliersByBusiness";
      var config = {
        params: {
          pag: 0,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProveedoresSub = [];
            vm.listProveedores = [];
            vm.listSuppliers = response.data.result.suppliers;
            if (response.data.result.suppliers.length === 0) {
              let proveedor = {
                name: vm.$t("sinProveedor"),
                id: 0,
                //porcentajeAcordado: 0,
              };

              vm.listProveedoresSub.push(proveedor);
              vm.listProveedores.push(proveedor);
            } else {
              if (!vm.idGasto) {
                vm.idSupplier = response.data.result.suppliers[0].id;
              }

              let proveedor = {
                name: vm.$t("sinProveedor"),
                id: 0,
                //porcentajeAcordado: 0,
              };

              vm.listProveedoresSub.push(proveedor);

              for (let i = 0; i < response.data.result.suppliers.length; i++) {
                let proveedorname = {
                  name: response.data.result.suppliers[i].name,
                  id: response.data.result.suppliers[i].id,
                  porcentajeAcordado: response.data.result.suppliers[i].porcentajeAcordado,
                };

                vm.listProveedoresSub.push(proveedorname);
                vm.listProveedores.push(proveedorname);
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCasas() {
      this.listCasas = [];

      const controller = "getCasasByBusiness";
      var config = {
        params: {
          pag: 0,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "casas/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.casas.length > 0) {
              vm.listCasas = response.data.result.casas;
            }

            let xCasa = {
              name: vm.$t("sinCasa"),
              id: "0",
            };

            vm.listCasas.unshift(xCasa);
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getGasto() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idHeader: this.idGasto,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "gastos/getExpensesById", config)
        .then(function (response) {
          if (response.data.response) {
            vm.tipo = response.data.result.tipo;
            vm.ref = response.data.result.ref;
            vm.fecha = moment
              .unix(response.data.result.fecha)
              .utc()
              .toISOString();
            vm.idSupplier = response.data.result.idSupplier;
            vm.observaciones = response.data.result.observaciones;
            vm.importe = response.data.result.importe;
            vm.base = response.data.result.base;
            vm.entradaAlmacen = response.data.result.entradaAlmacen;
            vm.incluirIVA = response.data.result.incluirIVA;
            vm.formaPago = response.data.result.formaPago;
            vm.verificado = response.data.result.verificado;
            vm.identificador = response.data.result.identificador;

            if (vm.verificado === 1) {

              vm.action = vm.$t("visualizar");
            } else if (vm.verificado === 0) {
              vm.action = vm.$t("modificar");
            } else {
              vm.action = vm.$t("nuevo");
            }


            if (response.data.result.detalles) {
              vm.listSubproductSelect = response.data.result.detalles;
              vm.listImportesIva = response.data.result.importesIva;
              for (
                let index = 0;
                index < vm.listSubproductSelect.length;
                index++
              ) {

                vm.changeProduct(vm.listSubproductSelect[index], true);
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    openModal(p, index) {
      this.idCasa = p.idCasa;
      this.indice = index;
      this.$modal.show("agregar-casa");
    },
    accionarModal() {
      this.listSubproductSelect[this.indice].idCasa = this.idCasa;

      var vm = this;
      this.listCasas.forEach(function (c) {
        if (vm.idCasa == c.id) {
          vm.nameCasa = c.name;
        }
      });
      this.listSubproductSelect[this.indice].nameCasa = this.nameCasa;
      this.$modal.hide("agregar-casa");
    },
    cerrarModal() {
      this.$modal.hide("modal-crear-subproductos");
      this.$modal.hide("modal-crear-proveedores");
    },
    selectSubproduct(idProducto) {
      let vm = this;

      this.idProducto = idProducto.id;

      this.listProductos.forEach(function (obj) {
        if (parseInt(obj.id) === parseInt(vm.idProducto)) {
          let precioCompraSinIva = 0;
          if (parseFloat(obj.precio_compra) !== 0) {

            precioCompraSinIva =
              parseFloat(obj.precio_compra) / (parseFloat(obj.iva) / 100 + 1);

          }

          let xProduct = {
            id: obj.id,
            dtoCompra: parseFloat(obj.dto_compra),
            escandallo: parseInt(obj.escandallo),
            guardarAlmacen: obj.guardar_almacen,
            idCasa: obj.idCasa,
            iva: parseFloat(obj.iva).toFixed(2),
            name: obj.name,
            precioCompra: parseFloat(obj.precio_compra),
            precioCompraSinIva: precioCompraSinIva,
            precioCompraInicial: parseFloat(obj.precio_compra),
            precioCompraSinIvaInicial: precioCompraSinIva,
            porcentajeCompra: parseFloat(obj.porcentajeCompra),
            base: 0,
            type: obj.type,
            und: "",
            partes: "",
            total: 0,
            nameCasa: obj.nameCasa,
            fixed_price_states: obj.fixed_price_state,
            porcentajeAcordado: obj.porcentajeAcordado
          };
          vm.idProducto = "";
          vm.listSubproductSelect.push(xProduct);
          vm.listProductos = [];
        }
      });
    },
    cuotaIvaModal(precioConIva, precioSinIva) {

      return round(precioConIva - precioSinIva, 4);

    },
    searchSubproductos(query, cb) {
      if (query !== "") {
        const controller = "searchSubproductsByGestionGasto/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              vm.listProductos = response.data.result.listSubproduct;
              cb(vm.listProductos);
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    checkGasto() {
      let check = true;
      const vm = this;


      if (this.ref === "") {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laReferenciaEsObligatoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        check = false;
      }

      if (this.idSupplier == 0) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("elProveedorEsObligatorio"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        check = false;
      }
      if (moment(this.fecha).unix() < 1) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laFechaEsObligatoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        check = false;
      }

      this.listSubproductSelect.forEach(function (d) {
        if (d.und === 0 && d.partes === 0) {
          swal({
            title: vm.$t("atencion"),
            text: vm.$t("hayUnaMateriaPrimaSinUnidades"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
          check = false;
        }

      });

      return check;
    },
    checkReference() {

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          ref: this.ref,
          idGasto: this.idGasto
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios.get(this.$store.getters.apiUrl + "gastos/checkIfReferenceExpenseExists", config)
        .then(function (response) {

          if (response.data.result) {

            swal({
              text: vm.$t("referenciaYaExiste"),
              confirmButtonClass: "btn btn-info btn-fill",
              confirmButtonText: vm.$t("guardarGasto"),
              cancelButtonText: vm.$t("cancelar"),
              showCancelButton: true,
              type: "warning",
            }).then((result) => {
              if (result.value) {
                vm.checkPriceIncrement();
              }

            });

          } else {
            vm.checkPriceIncrement();

          }

        }).catch(function (error) {
          console.log(error);
        });
    },     
    getPrecioFijadoTooltip(precioCompraSinIva, precioCompraSinIvaInicial) {

      if (this.idBusiness == 5831 && precioCompraSinIva && precioCompraSinIvaInicial) {
          const selectedSupplier = this.listProveedores.find(supplier => supplier.id === this.idSupplier);

        if (selectedSupplier) {
          this.porcentajeAcordado = selectedSupplier.porcentajeAcordado;
        } else {
        }
        const difference = precioCompraSinIva - precioCompraSinIvaInicial;
        const percentageChange = ((difference / precioCompraSinIvaInicial) * 100);
        if(percentageChange > this.porcentajeAcordado){
          return `Has modificado el precio  de ${this.formatCurrency(precioCompraSinIvaInicial)} a ${this.formatCurrency(precioCompraSinIva)}. Esto representa un incremento del ${percentageChange.toFixed(2)}%.`;

        }

      }
      return ''; 
    },
    checkAndShowAlert( newValue, oldValue, name) {



      if (this.idBusiness == 5831) {
        const selectedSupplier = this.listProveedores.find(supplier => supplier.id === this.idSupplier);
        if (selectedSupplier) {
          this.porcentajeAcordado = selectedSupplier.porcentajeAcordado;
        }

        if (this.porcentajeAcordado !=0 && newValue !== oldValue) {
          const incremento = ((newValue - oldValue) / oldValue) * 100;
          
          if(incremento > this.porcentajeAcordado){
            this.showPriceAlert(incremento, oldValue, newValue, name);

            const producto = this.listSubproductSelect.find(p => p.name === name);

            if (producto) {
              producto.precioHaCambiado = true; 
            }else{
              producto.precioHaCambiado = false; 
            }

           
          } else{
            const producto = this.listSubproductSelect.find(p => p.name === name);
              if (producto) {
                producto.precioHaCambiado = false; // Restablecer el aviso
              }
          }
        }
      }
    },

    showPriceAlert(incremento, oldValue, newValue, name) {
      const mensaje = incremento > 0
        ? `El precio del ${name} ha sido modificado, pasando de ${this.formatCurrency(oldValue)} a ${this.formatCurrency(newValue)}. Lo que representa un incremento del ${incremento.toFixed(2)} %.`
        : `El precio del ${name} ha sido modificado, pasando de ${this.formatCurrency(oldValue)} a ${this.formatCurrency(newValue)}. Lo que representa un descuento del ${Math.abs(incremento).toFixed(2)} %.`;

      const mensajeConNovedades = `
        ${mensaje}<br><br>
        Si deseas consultar esta nueva funcionalidad, consulta nuestras <a href="https://www.numier.com/engine/manuales/docs_Numier_ONLINE_gastos_proveedores_19_02_2025.pdf" style="color: #3085d6;">Novedades</a>.
      `;

      swal.fire({
        position: "center",
        title: this.$t('atencion'),
        type: "warning",
        html: mensajeConNovedades, 
        showCloseButton: false,
        reverseButtons: true,
        allowOutsideClick: false,
        showCloseButton: true,  
        closeButtonAriaLabel: 'Cerrar',
        showConfirmButton: true,
        confirmButtonText: this.$t('botonAceptar'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });
    },


    formatCurrency(value) {
      let formattedValue = value.toFixed(2);
      formattedValue = formattedValue.replace(',', '.');

      return `${formattedValue} €`;
    },

    checkPriceIncrement() {
      let incrementoSuperado = false;
      let mensaje = '';
      const selectedSupplier = this.listProveedores.find(supplier => supplier.id === this.idSupplier);

        if (selectedSupplier) {
          this.porcentajeAcordado = selectedSupplier.porcentajeAcordado;
        } else {
          
        }
      this.listSubproductSelect.forEach((subproducto, index, array) => {

        if (this.idBusiness == 5831 && this.porcentajeAcordado !=0 && subproducto.precioCompraSinIva !== subproducto.precioCompraSinIvaInicial) {
          const incremento = ((subproducto.precioCompraSinIva - subproducto.precioCompraSinIvaInicial) / subproducto.precioCompraSinIvaInicial) * 100;
          if (incremento > this.porcentajeAcordado) {
            incrementoSuperado = true;
            if (index < array.length - 1) {
              mensaje += `<br>· ${subproducto.name}: de ${subproducto.precioCompraSinIvaInicial.toFixed(2)} € a ${subproducto.precioCompraSinIva.toFixed(2)} €,`;
            } else {
              mensaje += `<br>· ${subproducto.name}: de ${subproducto.precioCompraSinIvaInicial.toFixed(2)} € a ${subproducto.precioCompraSinIva.toFixed(2)} €`;
            }
          }
        }
      });

      if (incrementoSuperado) {
        mensaje = `Se ha aumentado el precio de las siguientes materias primas con respecto al porcentaje acordado con el proveedor.<br> ${mensaje} <br><br>¿Desea guardar?`;
        swal.fire({
          position: "center",
          title: this.$t('atencion'),
          type: "warning",
          html: `<div style="text-align: left;">${mensaje}</div>`,
          showCloseButton: true,
          allowOutsideClick: false,
          showCancelButton: true,
          showConfirmButton: true,
          closeButtonAriaLabel: 'Cerrar',
          confirmButtonText: this.$t('botonAceptar'),
          cancelButtonText: this.$t("cancelar"),
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
        }).then((result) => {
          if (result.value) {
            this.saveGasto(incrementoSuperado);  
          }
        });
      } else {
        this.saveGasto(incrementoSuperado);
      }
    },
    saveGasto(incrementoSuperado) {

      if (this.checkGasto()) {
        this.base = this.getTotalBase;

        this.loading = Loading.service({ text: this.$t("guardandoGasto") });

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idBusiness: this.idBusiness,
          tipo: this.tipo,
          ref: this.ref,
          observaciones: this.observaciones,
          idSupplier: this.idSupplier,
          importe: this.importe,
          base: this.base,
          fecha: moment(this.fecha).unix(),
          entradaAlmacen: this.entradaAlmacen,
          incluirIVA: this.incluirIVA,
          listSubproducts: this.listSubproductSelect,
          jwt: this.$store.getters.jwt,
          idHeader: this.idGasto,
          formaPago: this.formaPago,
        };
        let vm = this;
        let controller = this.idGasto ? "editExpenseById" : "saveExpense";
        this.axios
          .post(
            this.$store.getters.apiUrl + "gastos/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.loading.close();

            if (response.data.response) {
              let notify = vm.idGasto ? vm.$t("actualizado") : vm.$t("creado");
              vm.$notify({
                message:
                  vm.$t("gasto") + " " + notify + " " + vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$router.push({
                name: "gestion-gastos",
                params: {
                  idBusiness: vm.idBusiness,
                  incrementoSuperado: incrementoSuperado,
                },
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.loading.close();
            vm.inProgress = false;
          });
      }
    },
    removeSubproduct(index) {


      this.listSubproductSelect.splice(index, 1);

      this.calcularIvaLista();

      this.listImportesIva.forEach((iva) => {

        iva.importe = iva.baseImponible * iva.IVA / 100;

      });


      this.base = this.getTotalBase;
      this.getTotalImpuesto;
      this.importe = this.getTotalTotal;

    },

    openModalnuevoSubproducto() {
      this.$modal.show("modal-crear-subproductos");
      this.getCategorySubpro();
      /*this.getProveedores();*/
      this.getCasas();
    },

    openModalnuevoProveedores() {
      this.$modal.show("modal-crear-proveedores");
      this.getCategoryProveedor();
    },

    getCategorySubpro() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategorySub = [];

            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinEtiqueta"),
                id: 0,
              };

              vm.listCategorySub.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinEtiqueta"),
                  id: 0,
                };

                vm.listCategorySub.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCategorySub.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getCategoryProveedor() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "suppliers/getTagsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listCategoryProveedor = [];

            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinCategoria"),
                id: 0,
              };

              vm.listCategoryProveedor.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinCategoria"),
                  id: 0,
                };

                vm.listCategoryProveedor.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCategoryProveedor.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getCategorySubpro() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategorySub = [];

            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinEtiqueta"),
                id: 0,
              };

              vm.listCategorySub.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinEtiqueta"),
                  id: 0,
                };

                vm.listCategorySub.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCategorySub.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getTaxes() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "taxes/getOnlyTaxes", config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.listIva = response.data.result;
              vm.subproducto.tipoIva = response.data.result[1];
            } else {
              vm.listIva = false;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    saveSubproducto() {

      if (this.checkCamposSubpro()) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          subproduct: this.subproducto,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "newSubproductByBusiness";
        this.axios
          .post(
            this.$store.getters.apiUrl + "subproducts/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              let notify = vm.$t("creada");
              vm.$notify({
                message:
                  vm.$t("materiaPrima") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$modal.hide("modal-crear-subproductos");
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkCamposSubpro() {
      if (this.subproducto.name.length > this.subproducto) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameSubproducto +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.subproducto.name === null ||
        this.subproducto.name.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },

    saveProveedor() {
      if (this.checkCampos()) {
        this.inProgress = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          supplier: this.proveedor,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = this.idProveedor
          ? "editSupplierById"
          : "newSupplierByBusiness";
        this.axios
          .post(
            this.$store.getters.apiUrl + "suppliers/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("creada");
              vm.$notify({
                message:
                  vm.$t("proveedor") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$modal.hide("modal-crear-proveedores");

              vm.getProveedores();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkCampos() {
      if (this.proveedor.name.length > this.maxNameProveedor) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameProveedor +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.proveedor.name === null ||
        this.proveedor.name.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },

    calculatePrice(subproduct, iva) {

      if (iva) {
        // var newPrice = parseFloat(
        //   subproduct.precioCompra / ((100 + subproduct.tipoIva) / 100)
        // ).toFixed(2);
        var newPrice = round(subproduct.precioCompra / ((100 + subproduct.tipoIva) / 100), 4)

        subproduct.precioCompraSinIva = newPrice;

      } else {
        // subproduct.precioCompra = (
        //   parseFloat(subproduct.precioCompraSinIva) +
        //   (parseFloat(subproduct.precioCompraSinIva) * subproduct.tipoIva) / 100
        // ).toFixed(2);
        subproduct.precioCompra = round(subproduct.precioCompraSinIva, 4) + round((parseFloat(subproduct.precioCompraSinIva) * subproduct.tipoIva) / 100, 4)
        subproduct.precioCompra = round(subproduct.precioCompra, 4)

      }
    },
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}

#layoutTipoDocumento {
  margin-top: 5px;
  margin-left: 5px;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #cdcdcd !important;
}

.el-select-dropdown__item {
  color: #111;
}

.bg-add-subproduct {
  background-color: #b3bec1a1 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Gastos/GestionGastoForm.vue